import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getInvoices: {
        method: 'GET',
        url: `${BASE_PATH_API}/invoices`,
        params: {
            '$count': true
        }
    },
    getInvoicesV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/invoices`,
        params: {
            '$count': true
        }
    },
    getInvoiceCount: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/invoices/count`
    },
    uploadInvoices: {
        method: 'POST',
        url: `${BASE_PATH_API}/v2/invoices/files`
    },
    deleteInvoice: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/v2/invoices/:id`
    },
    convertInvoiceToBill: {
        method: 'POST',
        url: `${BASE_PATH_API}/v2/invoices/bills`
    },
    updateDraftBill: {
        method: 'PATCH',
        url: `${BASE_PATH_API}/invoices`
    },
    getInvoiceOwners: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/invoices/owners`
    },
    getInvoiceExceptions: {
        method: 'GET',
        url: `${BASE_PATH_API}/invoiceprocessing/exceptions`
    },
    getInvoiceExceptionsV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/invoiceprocessing/v2/exceptions`,
        cache: true
    },
    getAutomatedInvoiceEntryHelpArticleUrl: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/invoices/automatedInvoiceEntryHelpArticleUrl`
    }
};

export function InvoicesApi() { return createActions(actions); }
